import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';
import './DangerZonePage.css';

const dangerTools = [
  {
    id: 'zero-location',
    title: 'Zero Out Location',
    description: 'Set every SKU\'s on-hand inventory to zero at a Shopify location, with a downloadable backup taken automatically first (and synced to the team Shared Drive). Shipping Pilot is never available here.',
    path: '/zero-location',
    badge: 'Destructive',
  },
];

export default function DangerZonePage() {
  const navigate = useNavigate();
  return (
    <div className="home">
      <h1>⚠ Danger-Zone Tools</h1>
      <p className="home-sub">
        These tools make irreversible or high-impact changes to live systems. Proceed carefully.
      </p>
      <div className="tool-grid">
        {dangerTools.map(t => (
          <button key={t.id} className="tool-card tool-card--danger" onClick={() => navigate(t.path)}>
            <span className="tool-badge tool-badge--danger">{t.badge}</span>
            <h2>{t.title}</h2>
            <p>{t.description}</p>
            <span className="tool-arrow">→</span>
          </button>
        ))}
      </div>
    </div>
  );
}
